import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'ibex-line-clamp',
    templateUrl: './ibex-line-clamp.component.html',
    styleUrls: ['./ibex-line-clamp.component.scss'],
    standalone: false
})

export class IbexLineClampComponent {
  @ViewChild('container') containerRef!: ElementRef;
  @ViewChild('header') headerRef!: ElementRef;
  @ViewChild('textBlock') textRef!: ElementRef;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.applyClamp();
    this.cdr.detectChanges();
  }

  @HostListener('window:resize')
  onResize() {
    this.applyClamp();
  }

  private applyClamp() {
    const containerHeight = this.containerRef.nativeElement.offsetHeight;
    const headerHeight = this.headerRef.nativeElement.offsetHeight;
    const availableHeight = containerHeight - headerHeight;

    const textEl = this.textRef.nativeElement;
    const lineHeight = parseFloat(getComputedStyle(textEl).lineHeight);

    const linesThatFit = Math.floor(availableHeight / lineHeight);
    textEl.style.webkitLineClamp = linesThatFit.toString();
  }
}
